import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyC9oB3IDusrgbcyQn39ERysy4c2CcQsPB0",
  authDomain: "service-subscription-portal.firebaseapp.com",
  projectId: "service-subscription-portal",
  storageBucket: "service-subscription-portal.firebasestorage.app",
  messagingSenderId: "589801306650",
  appId: "1:589801306650:web:e9d71334fbc29b511cefa3",
  measurementId: "G-TRB44HGX70"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
